<template>
  <div>
    <SellHeader :img_header="header_image" header="รายงานการขาย" link_back="sell/all"/>
    <Sell_report_all/>
  </div>
</template>

<script>
import SellHeader from "@/components/admin/sell/header_sell/SellHeader";
import HeaderImage from "@/assets/clipboard_report.png";
import Sell_report_all from "@/components/admin/sell/sell_report/Sell_report_all";
export default {
  name: "SellRepot",
  components: {
    Sell_report_all,
    SellHeader
  },
  data() {
    return {
      header_image: HeaderImage,
    }
  }
}
</script>

<style scoped>

</style>
